module.exports = __webpack_public_path__ + "img/loans-none.7e9e6b90.svg";